import { MethodsEnum } from "../enums/Methods.ts";
import { Convenio } from "../models/Convenio.ts";
import handleService from "./apiService.ts";

const create = async (convenio: Convenio) => {
  // id nunca deve ser enviado num cadastro novo - ver pacienteService.create para o motivo.
  const { id, ...convenioSemId } = convenio as any;
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/convenio",
    data: convenioSemId,
  });
  return result;
};

const update = async (convenio) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/convenio/alterar",
    data: convenio,
  });
  return result;
};

const getAll = async () => {
  const response = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/convenio",
  });
  if (response.data && Array.isArray(response.data)) {
    response.data.sort((a, b) => a.nome.localeCompare(b.nome));
  }
  return response;
};

const convenioService = { create, update, getAll };

export default convenioService;
